// Messaging API. Replaces Firestore chat collections.
//
// Thread list, detail, and message send are regular REST calls. Real-time
// updates come from short-poll on ``getThread`` with ``after=<last-id>``
// until a Channels-based WS landing is done (MIGRATION.md §2.1).

import { apiClient } from './apiClient';

export async function listThreads() {
  const { data } = await apiClient.get('/api/messages/threads/');
  return data?.threads ?? [];
}

export async function ensureThread({ participants, title = '' }) {
  const peers = Array.isArray(participants) ? participants : [participants];
  const { data } = await apiClient.post(
    '/api/messages/threads/',
    { participants: peers, title },
    { headers: { 'Content-Type': 'application/json' } },
  );
  return data;
}

export async function getThread(threadId, { after = 0, limit = 100 } = {}) {
  const { data } = await apiClient.get(
    `/api/messages/threads/${threadId}/`,
    { params: { after, limit } },
  );
  return data;
}

export async function sendMessage(
  threadId,
  { body = '', attachmentUrl = '', attachmentMime = '' } = {},
) {
  const { data } = await apiClient.post(
    `/api/messages/threads/${threadId}/`,
    {
      body,
      attachment_url: attachmentUrl,
      attachment_mime: attachmentMime,
    },
    { headers: { 'Content-Type': 'application/json' } },
  );
  return data;
}

export async function markThreadRead(threadId) {
  await apiClient.post(`/api/messages/threads/${threadId}/read/`);
}

// Aggregate unread-message count for the caller across every
// thread they participate in. Drives the navbar messages-icon
// badge. Backs ``GET /api/messages/unread-count/`` (writeon-django
// 80bc35b) — mirror of notifications/unread_count.
export async function getUnreadMessagesCount() {
  const { data } = await apiClient.get('/api/messages/unread-count/');
  return data?.unread_count ?? 0;
}
